import { Champ } from './champ';
import { Localisation, ILocalisationLibelle } from './localisation';

export interface ISection {
    id?: string;
    code: string;
    actif?: boolean;
    ordre: number;
    langues: Array<ISectionLibelle>;
    champs: Array<Champ>;
}

export interface ISectionLibelle extends ILocalisationLibelle {
    sectionId?: string;
}

export class Section extends Localisation<ISectionLibelle> implements ISection {

    id?: string;
    code: string;
    actif?: boolean;
    ordre: number;
    champs: Array<Champ>;

    constructor(section: ISection) {
        super(section.langues);

        this.id = section.id;
        this.code = section.code;
        this.actif = section.actif;
        this.ordre = section.ordre;
        this.champs = section.champs;
    }

    static fromJson(section: any) {
        return new Section({
            id: section.sec_id,
            code: section.sec_code,
            actif: section.sec_actif,
            ordre: parseInt(section.sec_ordre, 10),
            langues: section.langues.map(langue => {
                return {
                    id: langue.sel_id,
                    champId: langue.sel_sec_id,
                    langueId: langue.sel_lng_id,
                    libelle: langue.sel_libelle
                };
            }),
            champs: section.champs ? section.champs.map(champ => {
               return Champ.fromJson(champ);
            }) : []
        });
    }


    toJson() {
        return {
            sec_id: this.id,
            sec_actif: this.actif,
            sec_ordre: this.ordre,
            sec_code: this.code,
            langues: this.langues.map(langue => {
                return {
                    sel_id: langue.id,
                    sel_sec_id: langue.sectionId,
                    sel_lng_id: langue.langueId,
                    sel_libelle: langue.libelle
                };
            }),
            champs: this.champs.map(champ => {
                return champ.toJson();
            })
        };
    }

    toSectionJson() {
        return {
            sec_id: this.id,
            sec_actif: this.actif,
            sec_ordre: this.ordre,
            sec_code: this.code
        };
    }

    toChampSectionJson() {
        return {
            sec_id: this.id,
            sec_actif: this.actif,
            sec_ordre: this.ordre,
            sec_code: this.code,
            langues: this.langues.map(langue => {
                return {
                    sel_id: langue.id,
                    sel_sec_id: langue.sectionId,
                    sel_lng_id: langue.langueId,
                    sel_libelle: langue.libelle
                };
            }),
            champs: this.champs.map(champ => {
                return champ.toChampOngletSectionJson();
            })
        };
    }

    getChampsByColonne(colonneNumber: number) {
        return this.champs
            .filter(champ => champ.champOngletColonne === colonneNumber && champ.champOngletSection === this.id)
            .sort((a, b) => a.champOngletColonne - b.champOngletColonne);
    }

    findChampIndexByCoordonates(column: number, row: number): number {
        return this.champs.findIndex(champ => champ.champOngletOrdre === row && champ.champOngletColonne === column);
    }

    findChampByCoordonates(column: number, row: number): Champ {
        return this.champs[this.findChampIndexByCoordonates(column, row)];
    }
}

